export const getConfig = () => ({
  publicRuntimeConfig: {
    assetPrefix: '/ustorethemes/ACSReprintsv1d',
    apiUrl: '/uStoreRestAPI',
    classicUrl: '/ustore',
    themeCustomizationUrl: '/uStoreThemeCustomizations',
    serverDomain: 'http://localhost:5000'
  }
})
